export const SET_USER_DATA = "SET_USER_DATA";
export const SET_ADMIN_DATA = "SET_ADMIN_DATA";

export const setUserData = (userData) => ({
  type: SET_USER_DATA,
  userData,
});
export const setAdminData = (adminData) => ({
  type: SET_ADMIN_DATA,
  adminData,
});
